<template>
	<MobileLayout>
		<MobileHeader :logoColor="'white'" />

		<!-- 自然撑开的内容区，无固定高度 -->
		<div class="page-content">
			<section class="m-hero">
				<div class="m-hero-track" ref="heroTrack">
					<div v-for="(img, i) in heroImages" :key="i" class="m-hero-slide">
						<img :src="img" alt="Product" />
					</div>
				</div>
			</section>

			<section class="m-info font-apercu-medium">
				<div class="m-title">
					<span>{{ productName }}</span>
					<!-- ★ 点击切换爱心 -->
					<span style="float: right; cursor: pointer;" @click="toggleLike">
						<img :src="isLiked ? like : unlike" style="width: 16rem; height: 16rem; display: inline-flex; align-items: center;" />
					</span>
				</div>
				<div class="m-specs">
					<div class="m-spec-row">
						<span class="m-spec-label">Dimension</span>
						<span class="m-spec-value">
							L {{ product.DimensionLength }}
							<span style="margin: 0px 15px;">
								W {{ product.DimensionWidth }}
							</span>
							H {{ product.DimensionHeight }}
						</span>
					</div>
					<div class="m-spec-row">
						<span class="m-spec-label">Material</span>
						<span class="m-spec-value">{{ productMaterial }}</span>
					</div>
					<div class="m-spec-row">
						<span class="m-spec-label">Color</span>
						<span class="m-spec-value">{{ productFinish }}</span>
					</div>
				</div>
				<div v-if="showSizeRange" class="m-specs">
					<div class="m-spec-row">
						<span class="m-spec-label">Minimum Size</span>
						<span class="m-spec-value">
							L {{ product.MinimumLength }}
							<span style="margin: 0px 15px;">
								W {{ product.MinimumWidth }}
							</span>
							H {{ product.MinimumHeight }}
						</span>
					</div>
					<div class="m-spec-row">
						<span class="m-spec-label">Maximum Size</span>
						<span class="m-spec-value">
							L {{ product.MaximumLength }}
							<span style="margin: 0px 15px;">
								W {{ product.MaximumWidth }}
							</span>
							H {{ product.MaximumHeight }}
						</span>
					</div>
				</div>
			</section>

			<section class="m-actions font-apercu-medium">
			  <!-- 定制复选框 -->
			  <div class="m-customise-toggle" style="margin-left:6rem; display: flex; justify-content: space-between; align-items: center; width: 100%;">
			    <label class="m-checkbox">
			      <input type="checkbox" v-model="isCustomise" />
			      <img :src="isCustomise ? ckedIcon : ckIcon" class="m-check-icon" alt="checkbox" />
			      Customise
			    </label>
			    <div v-if="!isCustomise" class="m-action-solid" @click="enquire" style="margin-right: 6rem;">[Enquire]</div>
			  </div>

			  <!-- 定制输入框（条件显示） -->
			  <transition name="expand">
			    <div v-if="isCustomise" class="m-customise-input-wrapper"  style="margin-left:6rem;">
			      <div class="m-input-wrapper">
			        <textarea
			          ref="customInput"
			          v-model="customMessage"
			          class="m-customise-textarea"
			          rows="1"
			          @focus="inputFocused = true"
			          @blur="inputFocused = false"
			          @input="resizeInput"
			        ></textarea>
			        <label
			          class="m-floating-label"
			          :class="{
			            'has-text': customMessage && customMessage.length > 0,
			            focused: inputFocused
			          }"
			        >
			          Specify your customisation here.
			        </label>
			      </div>
			    </div>
			  </transition>

			  <!-- Enquire 按钮 -->
			  <div class="m-enquire-wrapper">
			    <div v-if="isCustomise" class="m-action-solid" @click="enquire">[Enquire]</div>
			  </div>
			</section>
		</div>

		<MobileFooter style="margin-top: 60rem;margin-bottom: 80rem;" />

		<div class="m-hero-mask"></div>
	</MobileLayout>
</template>

<script>
import MobileLayout from '@/components/mobile/MobileLayout.vue'
import MobileFooter from '@/components/mobile/footer.vue'
import MobileHeader from '@/components/mobile/header.vue'
import {
	getProductDetail
} from '@/api/product'
import {
	getUser
} from '@/config/auth'
import {
	addToCart,
	getCartItems,
	removeFromCart    // ★ 移除购物车项（登录态）
} from '@/api/Enquiry'
import {
	addToLocalCart,
	getLocalCart,
	removeFromLocalCart   // ★ 移除本地购物车项（未登录态）
} from '@/utils/localCart'

const placeholderImage = require('@/assets/Group 1-2.png')
const brandLogo = require('@/assets/mobile/home/logo.png')

export default {
	name: 'MobileProductDetail',
	components: {
		MobileLayout,
		MobileFooter,
		MobileHeader
	},
	data() {
		return {
			loading: false,
			product: {},
			brandLogo,
			customMessage: '',
			heroImages: [],
			showSizeRange: false,
			isCustomise: false,
			inputFocused: false,
			ckIcon: require('@/assets/mobile/icon/ck.png'),
			ckedIcon: require('@/assets/mobile/icon/cked.png'),
			like: require('@/assets/like.png'),      // 实心爱心
			unlike: require('@/assets/unlike.png'),  // 空心爱心
			isLiked: false,          // 是否已加入询价
			cartItemId: null,        // 登录态：CartID；未登录态：localId
			likeLoading: false       // ★ 防止爱心连点
		}
	},
	computed: {
		productName() {
			return this.product.ProductName || 'Product Detail'
		},
		productMaterial() {
			return this.product.Material || 'Custom material'
		},
		productFinish() {
			return this.product.Color || 'Custom finish'
		},
		productSize() {
			const p = this.product
			if (!p.DimensionLength && !p.DimensionWidth && !p.DimensionHeight) return 'Made to order'
			const parts = []
			if (p.DimensionLength) parts.push(`L ${p.DimensionLength}    `)
			if (p.DimensionWidth) parts.push(`W ${p.DimensionWidth}   `)
			if (p.DimensionHeight) parts.push(`H ${p.DimensionHeight}`)
			return parts.join(' ')
		}
	},
	mounted() {
		this.fetchDetail()
		this.$nextTick(() => {
			this.resizeInput()
		})
		window.scrollTo(0, 0)
	},
	// ★ 注意：这里不再加 beforeRouteLeave，避免浏览器返回时把菜单关掉
	methods: {
		// ★ 只广播事件：让 Menu.vue 收到后走它自己的 closeMenu()
		//    浏览器返回 / 用户手动后退不会触发这里，菜单状态维持原样
		closeGlobalMenu() {
			window.dispatchEvent(new CustomEvent('close-mobile-menu'))
			sessionStorage.removeItem('menuState')   // 保留，和 Menu.vue 里形成双保险
			document.body.style.overflow = ''
			document.documentElement.style.overflow = ''
		},

		scrollPageToTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
		},
		resetHeroScroll() {
			this.$nextTick(() => {
				if (this.$refs.heroTrack) {
					this.$refs.heroTrack.scrollTop = 0;
				}
			});
		},
		resizeInput() {
			const el = this.$refs.customInput
			if (!el) return
			el.style.height = 'auto'
			el.style.height = el.scrollHeight + 'px'
		},
		async fetchDetail() {
			const productId = this.$route.params.id;
			if (!productId) {
				this.showMessage('error', 'Product ID missing');
				return;
			}

			this.loading = true;
			try {
				const response = await getProductDetail(productId, 'mobile');
				console.log(response)
				const detail = response.result || response;
				if (!detail) {
					this.showMessage('error', 'Product not found');
					return;
				}
				this.product = detail;
				this.updateHeroImages();
				this.resetHeroScroll();
				this.scrollPageToTop();
				await this.checkCartStatus();
			} catch (error) {
				console.error('Failed to load product detail:', error);
				this.showMessage('error', 'Failed to load product');
			} finally {
				this.loading = false;
			}
		},
		updateHeroImages() {
			const images = []
			const product = this.product

			if (product.Images && product.Images.length) {
				product.Images.forEach(img => {
					if (img.ImageURL && img.ImageType !== 'main') {
						images.push(img.ImageURL)
					}
				})
			} else if (product.image) {
				images.push(product.image)
			}

			if (images.length === 0) images.push(placeholderImage)
			// if (images.length === 1) images.push(images[0])
			this.heroImages = images
		},
		showMessage(type, message) {
			window.dispatchEvent(
				new CustomEvent('app-message', {
					detail: {
						type,
						title: type === 'success' ? 'Success' : 'Error',
						message
					}
				})
			)
		},
		getMainImage() {
			if (!this.product.Images || this.product.Images.length === 0) {
				return ''
			}
			const mainImage = this.product.Images.find(img => img.ImageType === 'main')
			return mainImage ? mainImage.ImageURL : this.product.Images[0].ImageURL || ''
		},

		// ★ 兼容多种返回结构，从接口结果里取数组
		normalizeCartList(res) {
			if (!res) return []
			if (Array.isArray(res)) return res
			if (Array.isArray(res.result)) return res.result
			if (Array.isArray(res.data)) return res.data
			if (Array.isArray(res.items)) return res.items
			if (Array.isArray(res.list)) return res.list
			if (res.result && Array.isArray(res.result.items)) return res.result.items
			if (res.result && Array.isArray(res.result.list)) return res.result.list
			return []
		},

		// ★ 兼容多种 CartID 字段名
		pickCartId(item) {
			if (!item) return null
			return item.CartID || item.CartId || item.cartId || item.cart_id
				|| item.CartItemID || item.CartItemId || item.id || null
		},

		// ★ 判断接口是否成功（兼容 retCode / code / success）
		isOk(response) {
			if (!response) return false
			if (response.retCode === 1) return true
			if (response.code === 1 || response.code === 200) return true
			if (response.success === true) return true
			return false
		},

		// ★ 检查购物车状态
		//   - 登录态：cartItemId = CartID
		//   - 未登录态：cartItemId = localId（removeFromLocalCart 需要 localId）
		async checkCartStatus() {
			const productId = this.product.ProductID
			if (!productId) return

			const user = getUser()

			if (user) {
				let list = []
				try {
					const res = await getCartItems(user.UserID)
					list = this.normalizeCartList(res)
				} catch (e) {
					console.warn('获取购物车失败', e)
					return
				}
				const found = list.find(item => item.ProductID === productId)
				this.isLiked = !!found
				this.cartItemId = found ? this.pickCartId(found) : null
			} else {
				const list = getLocalCart() || []
				const found = list.find(item => item.ProductID === productId)
				this.isLiked = !!found
				this.cartItemId = found ? found.localId : null
			}
		},

		// ★ 点击爱心：已加入→移除；未加入→加入
		async toggleLike() {
			if (this.likeLoading) return
			if (this.isLiked) {
				await this.removeFromEnquiry()
				return
			}
			this.enquire()
		},

		// ★ 从询价购物车移除当前商品
		async removeFromEnquiry() {
			const productId = this.product.ProductID
			if (!productId) return

			this.likeLoading = true
			const user = getUser()

			// ---------- 未登录：操作本地购物车 ----------
			if (!user) {
				try {
					const cart = getLocalCart() || []
					const found = cart.find(item => item.ProductID === productId)

					if (!found) {
						this.isLiked = false
						this.cartItemId = null
						this.likeLoading = false
						return
					}

					// ★ 传 localId，而不是 productId
					removeFromLocalCart(found.localId)

					// ★ removeFromLocalCart 无返回值，删完重新读取校验
					const after = getLocalCart() || []
					const stillExists = after.some(item => item.ProductID === productId)

					if (!stillExists) {
						this.isLiked = false
						this.cartItemId = null
					} else {
						this.showMessage('error', 'Remove failed')
					}
				} catch (e) {
					console.error('Remove local cart error:', e)
					this.showMessage('error', 'Remove failed')
				} finally {
					this.likeLoading = false
				}
				return
			}

			// ---------- 已登录：调用接口 ----------
			let cartId = this.cartItemId

			if (!cartId) {
				try {
					const res = await getCartItems(user.UserID)
					const list = this.normalizeCartList(res)
					const found = list.find(item => item.ProductID === productId)
					cartId = found ? this.pickCartId(found) : null
				} catch (e) {
					console.warn('获取购物车失败', e)
				}
			}

			if (!cartId) {
				this.isLiked = false
				this.cartItemId = null
				this.likeLoading = false
				return
			}

			try {
				const response = await removeFromCart(cartId, user.UserID)

				if (this.isOk(response)) {
					this.isLiked = false
					this.cartItemId = null
				} else {
					this.showMessage('error', response.retMsg || response.message || 'Remove failed')
				}
			} catch (error) {
				console.error('Remove from cart error:', error)
				this.showMessage('error', 'Network error, please try again')
			} finally {
				this.likeLoading = false
			}
		},

		async enquire() {
			const user = getUser()

			// ---------- 未登录：写本地购物车 ----------
			if (!user) {
				const imageUrl = this.getMainImage()
				const success = addToLocalCart(
					this.product.ProductID,
					this.customMessage,
					imageUrl,
					this.product.CategoryName || '',
					this.product.ProductName
				)
				if (success) {
					const cart = getLocalCart() || []
					const found = cart.find(item => item.ProductID === this.product.ProductID)
					this.isLiked = true
					this.cartItemId = found ? found.localId : null

					this.closeGlobalMenu()               // ★ 先关菜单
					this.$router.push('/m/enquiry')      // ★ 再跳转
					this.customMessage = ''
				} else {
					this.showMessage('error', 'Product already in enquiry list')
				}
				return
			}

			// ---------- 已登录：调接口 ----------
			const model = {
				ProductID: this.product.ProductID,
				UserID: user.UserID,
				CustomisationText: this.customMessage || ''
			}
			try {
				const response = await addToCart(model)
				if (this.isOk(response)) {
					const result = response.result || response.data || null
					this.isLiked = true
					this.cartItemId = this.pickCartId(result)

					this.closeGlobalMenu()               // ★ 先关菜单
					this.$router.push('/m/enquiry')      // ★ 再跳转
					this.customMessage = ''
				} else {
					this.showMessage('error', response.retMsg || response.message || 'Add to cart failed')
				}
			} catch (error) {
				console.error('Add to cart error:', error)
				this.showMessage('error', 'Network error, please try again')
			}
		}
	}
}
</script>

<style scoped>
/* ★ 原有所有样式保持不变 */
.m-hero {
	height: 460rem;
	overflow: hidden;
	border-bottom: 1rem solid #000;
}

.m-hero-mask {
	position: fixed;
	left: 0;
	bottom: 45rem;
	width: 100%;
	height: 42rem;
	background: linear-gradient(
		180deg,
		#FFFFFF 59.52%,
		rgba(255, 255, 255, 0) 108.33%
	);
	transform: rotate(-180deg);
	pointer-events: none;
	z-index: 40;
}

.m-hero-track {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	z-index: 999;
}

.m-hero-slide {
	flex: 0 0 auto;
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	margin-bottom: 2rem;
}
.m-hero-slide:last-child {
	margin-bottom: 0;
}
.m-hero-slide img {
	width: auto;
	max-width: 100%;
	height: auto;
	display: block;
}

.m-hero-track::-webkit-scrollbar,
.m-hero-slide::-webkit-scrollbar {
	display: none;
}

.m-brand-img {
	position: absolute;
	top: 0rem;
	left: 0rem;
	width: 92%;
	pointer-events: none;
	mix-blend-mode: multiply;
}

.m-sub-hero img {
	width: 100%;
	height: 180rem;
	object-fit: cover;
}

.m-info {
	position: relative;
	padding: 28rem 25rem 8rem;
	display: flex;
	flex-direction: column;
	gap: 20rem;
}

.m-title {
	font-size: 16rem;
	font-weight: 500;
	text-underline-offset: 3rem;
}

.m-specs {
	display: flex;
	flex-direction: column;
	font-size: 10rem;
	font-weight: 500;
	margin-left: 6rem;
}

.m-spec-row {
	display: grid;
	grid-template-columns: 120rem 1fr;
	gap: 18rem;
	font-size: 10rem;
}

.m-spec-label {
	color: #000;
	font-weight: 500;
}

.m-spec-value {
	color: #000;
	font-weight: 500;
}

.m-note {
	font-size: 10rem;
	color: #000;
	margin-top: 15rem;
}

.m-actions {
	padding: 20rem 25rem 0rem;
	display: flex;
	flex-direction: column;
}

.m-customise-toggle {
	display: flex;
	align-items: center;
}
.m-checkbox {
	display: inline-flex;
	align-items: center;
	gap: 8rem;
	font-size: 10rem;
	font-weight: 500;
	color: #000;
	-webkit-tap-highlight-color: transparent;
	user-select: none;
	cursor: pointer;
}
.m-checkbox input {
	display: none;
}
.m-check-icon {
	width: 10rem;
	height: 10rem;
	display: inline-block;
	flex-shrink: 0;
}

/* 展开动画 */
.expand-enter-active,
.expand-leave-active {
	transition: all 0.3s ease;
	max-height: 120px;
	opacity: 1;
	overflow: hidden;
}
.expand-enter,
.expand-leave-to {
	max-height: 0;
	opacity: 0;
	margin-top: 0;
}

.m-customise-input-wrapper {
	overflow: hidden;
}
.m-input-wrapper {
	position: relative;
	width: 100%;
}
.m-customise-textarea {
	width: 100%;
	border: none;
	border-bottom: 1rem solid #000;
	padding: 8rem 0 1rem 0;
	font-size: 10rem;
	font-family: 'Apercu', sans-serif;
	resize: none;
	color: #000;
	background: transparent;
	outline: none;
	min-height: 24rem;
	margin-top: 15rem;
}
.m-floating-label {
	position: absolute;
	left: 0;
	bottom: 5rem;
	font-size: 10rem;
	color: #999;
	pointer-events: none;
	transition: all 0.2s ease;
	white-space: nowrap;
}
.m-floating-label.has-text,
.m-floating-label.focused {
	display: none;
}

.m-enquire-wrapper {
	display: flex;
	justify-content: flex-end;
	margin-top: 8rem;
}
.m-action-solid {
	border: none;
	font-size: 10rem;
	text-align: center;
	height: 28rem;
	border-radius: 16rem;
	cursor: pointer;
	font-family: 'Apercu-Medium', sans-serif;
	display: inline-flex;
	align-items: center;
}

.page-content {
	/* 无固定高度，自然撑开，外部容器可滚动 */
}

.toggle-size-btn {
	display: inline-block;
	width: 20px;
	text-align: center;
	user-select: none;
	transition: transform 0.2s;
}
.toggle-size-btn:active {
	transform: scale(0.9);
}
</style>